import { c as _c } from "react/compiler-runtime";
import { shopAsset } from '@utils/utils-config';
import Image from 'next/image';
import type { ReactNode } from 'react';
type AddedToCartItemDetailsProps = {
  title: string;
  subTitle: string | ReactNode;
  image?: ReactNode;
};
export function AddedToCartItemDetails(t0) {
  const $ = _c(12);
  const {
    title,
    subTitle,
    image
  } = t0;
  let t1;
  if ($[0] !== image) {
    t1 = <div className="aspect-square h-16">{image}</div>;
    $[0] = image;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <p className="font-body-small font-semibold">{title}</p>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== subTitle) {
    t3 = <p className="font-body-small">{subTitle}</p>;
    $[4] = subTitle;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="flex flex-col gap-1">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <div className="mb-4 flex flex-row items-center gap-4">{t1}{t4}</div>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
type AddedToCartItemImageProps = {
  image?: {
    url?: string | null;
    alt?: string | null;
  };
};
export function AddedToCartItemImage(t0) {
  const $ = _c(5);
  const {
    image
  } = t0;
  let t1;
  if ($[0] !== image?.url) {
    t1 = image?.url ?? shopAsset("/images/7f-logo-fallback.svg");
    $[0] = image?.url;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = image?.alt ?? "";
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <Image src={t1} alt={t2} width="70" height="70" className="aspect-square h-16 rounded-xl object-cover" priority={true} />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}